import { EntityId } from '@reduxjs/toolkit';
import { ROUTER_API } from 'app/constants/api.constant';
import { ListObject } from 'app/main/design-system/models/listObjectsModel';
import BaseApi from 'app/services/api/base.api';
import { GameInDTO, GameInfoDTO, GameListItemDTO, GameOutDTO, GameRewardsDTO } from '../types';

export const gameApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

export const createGameApi = async (request: GameOutDTO) => {
  const response = await gameApi.api.post<GameInDTO>(`api/v2/games`, request, {});
  return response.data;
};

export const fetchGamesApi = async (page?: number, size?: number) => {
  const response = await gameApi.api.get<ListObject<GameListItemDTO>>(`api/v2/games/owned`, {
    params: { page, size },
  });
  return response.data;
};

export const fetchGameInfoApi = async (gameId: EntityId) => {
  const response = await gameApi.api.get<GameInfoDTO>(`api/v2/games/${gameId}/info/owner`);
  return response.data;
};

export const fetchGameRewardsApi = async (gameId: EntityId, includeDisabled?: boolean) => {
  const response = await gameApi.api.get<GameRewardsDTO[]>(`api/v2/games/${gameId}/rewards`, {
    params: { includeDisabled },
  });
  return response.data;
};

export const updateGameStatusApi = async (gameId: EntityId, disabled: boolean) => {
  const response = await gameApi.api.patch<GameInDTO>(`api/v2/games/${gameId}/status`, { disabled });
  return response.data;
};
